import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ButtonComponent } from './button/button.component';
import { TextInputComponent } from './text-input/text-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardComponent } from './card/card.component';
import { SliderComponent } from './slider/slider.component';
import { IconSvgComponent } from './icon-svg/icon-svg.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TabComponent } from './tab/tab.component';
import { ModalComponent } from './modal/modal.component';
import { ToastPopupComponent } from './toast-popup/toast-popup.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/auth/auth.api';
import { DownIconComponent } from '../../@icons/down-icon.component';
import { LoadingIconComponent } from "../../@icons/loading-icon.component";
import { SkeletonLoaderComponent } from '../@components/loaders/skeleton-loader/skeleton-loader.component';
import { CardBlockTitleComponent } from '../@components/cards/card-block-title/card-block-title.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { ThreeDotsIconComponent } from '../../@icons/three-dots-icon.component';
import { CloseIconComponent } from '../../@icons/close-icon.component';
import { ChoiceSelectorComponent } from './choice-selector/choice-selector.component';
import { QuantityStepperComponent } from './quantity-stepper/quantity-stepper.component';
import { ActionBadgeComponent } from './action-badge/action-badge.component';
import { ZoneNamePipe, HasCustomZoneNamePipe } from '../pipes/zone-name.pipe';

@NgModule({
  declarations: [
    ButtonComponent,
    IconButtonComponent,
    TextInputComponent,
    CardComponent,
    SliderComponent,
    IconSvgComponent,
    DropdownComponent,
    CardComponent,
    ModalComponent,
    ToastPopupComponent,
    TabComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxSliderModule,
    ReactiveFormsModule,
    TranslatePipe,
    DownIconComponent,
    LoadingIconComponent,
    SkeletonLoaderComponent,
    CardBlockTitleComponent,
    ThreeDotsIconComponent,
    CloseIconComponent,
    ChoiceSelectorComponent,
    QuantityStepperComponent,
    ActionBadgeComponent,
    ZoneNamePipe,
    HasCustomZoneNamePipe
  ],
  exports: [
    ButtonComponent,
    IconButtonComponent,
    TextInputComponent,
    SliderComponent,
    IconSvgComponent,
    DropdownComponent,
    CardComponent,
    ModalComponent,
    ToastPopupComponent,
    TabComponent,
    ChoiceSelectorComponent,
    QuantityStepperComponent,
    ActionBadgeComponent,
    ZoneNamePipe,
    HasCustomZoneNamePipe
  ]
})
export class SharedModule { }
